module.exports = __webpack_public_path__ + "static/research_card_img1@2x-4381dccaf4a9e10bc1192f2cf9045b31.jpg";